import { useDataset } from '@infinex/user';

import { useOptimisticUiStateStore } from '../../stores/optimistic-ui-state';

/**
 * Returns optimistic UI state via datasets (plus optimistic updates in store)
 */
export function useOptimisticUserUiState() {
  const userDataset = useDataset('user');

  const applyOptimisticUpdates = useOptimisticUiStateStore(
    (state) => state.makeOptimisticState
  );

  // Subscribe in order to rerender
  const _updateVersion = useOptimisticUiStateStore(
    (state) => state.updateVersion
  );

  // Compute the optimistic UI state
  const optimisticUiState = applyOptimisticUpdates(userDataset.data?.uiState);

  return {
    ...userDataset,
    data: optimisticUiState,
  };
}

/**
 * Returns the list of chains where the Pectra deposit address has been seen
 */
export function useSeenPectraDepositAddresses() {
  const uiStateResult = useOptimisticUserUiState();
  return uiStateResult.data?.hasSeenPectraDepositAddress ?? {};
}

/**
 * Returns whether the user has blurred their account balances
 */
export function useShouldBlurAccountBalances() {
  const { data: uiState } = useOptimisticUserUiState();
  return uiState?.blurAccountBalances ?? false;
}
